import { render, staticRenderFns } from "./Banniere.vue?vue&type=template&id=2c0d2616&scoped=true&lang=html&"
import script from "./Banniere.vue?vue&type=script&lang=js&"
export * from "./Banniere.vue?vue&type=script&lang=js&"
import style0 from "./Banniere.vue?vue&type=style&index=0&id=2c0d2616&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0d2616",
  null
  
)

export default component.exports